module.exports = __webpack_public_path__ + "static/img/20.fd43596.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/20.png
// module id = rGA3
// module chunks = 0